import React from "react";
import { Box, Typography, Grid, TextField } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import DisplayCheck from "./DisplayCheck";

const FormGrid = styled(Grid)`
  .MuiGrid-item {
    padding-bottom: 0;
  }
  margin-bottom: 25px;
`;

const MedicalInfo = () => {
  const { t } = useTranslation();

  return (
    <Box my={2} mx={3}>
      <FormGrid container spacing={5}>
        <Grid item xs={6} padd>
          <TextField
            disabled
            label={t("student.medical.height")}
            value="1,59 m"
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.weight")}
            value="49 Kg"
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <DisplayCheck disabled label={t("student.medical.bloodType")}>
            A
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <DisplayCheck disabled label={t("student.medical.rhFactor")}>
            -
          </DisplayCheck>
        </Grid>

        <Grid item xs={12}>
          <DisplayCheck disabled label={t("student.medical.allergy")}>
            {t("common.actions.yes")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.trigger")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.spec")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.procedure")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6} />

        <Grid item xs={6}>
          <DisplayCheck fullWidth label={t("student.medical.seriousIllness")}>
            {t("common.actions.yes")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.which")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <DisplayCheck disabled fullWidth label={t("student.medical.surgery")}>
            {t("common.actions.no")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6} />

        <Grid item xs={6}>
          <DisplayCheck fullWidth label={t("student.medical.treatment")}>
            {t("common.actions.yes")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.which")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <DisplayCheck
            disabled
            fullWidth
            label={t("student.medical.physicalRestrictions")}
          >
            {t("common.actions.yes")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.reason")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <DisplayCheck
            disabled
            fullWidth
            label={t("student.medical.hasInsurance")}
          >
            {t("common.actions.yes")}
          </DisplayCheck>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.which")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Box mt={2}>
            <Typography variant="body1" color="textSecondary" margin>
              {t("student.medical.recommendedHospital")}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.hospital")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.address")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.neighborhood")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.phone")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Box mt={2}>
            <Typography variant="h4">{t("student.medical.ifHas")}</Typography>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.symptom")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6} />

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.medication")}
            value={null}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled
            label={t("student.medical.dosage")}
            value={null}
            fullWidth
          />
        </Grid>
      </FormGrid>
    </Box>
  );
};

export default MedicalInfo;
